import SendbirdChat from "@sendbird/chat"
import { GroupChannelModule } from "@sendbird/chat/groupChannel"

const SENDBIRD_INFO = process.env.REACT_APP_SENDBIRD_KEY || ""

export const sendbirdChat = SendbirdChat.init({
  appId: SENDBIRD_INFO,
  localCacheEnabled: true,
  modules: [new GroupChannelModule()],
})

export const createChannel = async (
  channelName: string,
  userIdsToInvite: string[],
) => {
  try {
    // const groupChannelParams = {};
    // groupChannelParams.invitedUserIds = userIdsToInvite;
    // groupChannelParams.name = channelName;
    // groupChannelParams.operatorUserIds = userIdsToInvite;
    const groupChannel = await sendbirdChat.groupChannel.createChannel({
      invitedUserIds: userIdsToInvite,
      name: channelName,
    })
    return groupChannel
  } catch (error) {
    return error
  }
}
